import React, { createContext, useContext } from 'react'
import { Platform, StyleSheet } from 'react-native'
import { Theme } from '../theme'

export type RoutePath = '/' | '/features' | '/pricing' | '/vision' | '/privacy' | '/terms'
export type RouteState = { path: RoutePath; hash?: string }

export type LeadFormData = {
  firstName: string
  lastName: string
  email: string
  phone: string
  country: string
  customCountry: string
  preferredLanguage: string
  customLanguage: string
  usageType: string
  companySize: string
  callVolume: string
  inboundCallTypes: string[]
  customInboundCallType: string
  currentSystem: string
  idealAssistantDescription: string
  interestedInBeta: boolean
}

export const IS_WEB = Platform.OS === 'web'
export const HEADER_HEIGHT = 84
export const MAX_WIDTH = 1280
export const legalParagraphStyle = {
  fontSize: 16,
  lineHeight: 27,
}

export function baseFont(weight: '400' | '500' | '700' | '900' = '400') {
  return {
    fontFamily: IS_WEB ? 'Inter, sans-serif' : undefined,
    fontWeight: weight,
  } as const
}

export function monoFont() {
  return {
    fontFamily: IS_WEB ? '"JetBrains Mono", monospace' : undefined,
    fontWeight: '700',
  } as const
}

export function eyebrow(theme: Theme) {
  return {
    ...baseFont('700'),
    color: theme.colors.primary,
    fontSize: 10,
    textTransform: 'uppercase',
    letterSpacing: 1.6,
  } as const
}

export function pricingTextColor(theme: Theme, highlighted?: boolean) {
  if (!highlighted) {
    return theme.colors.text
  }

  return theme.dark ? theme.colors.background : theme.colors.staticWhite
}

export function pricingSubtleColor(theme: Theme, highlighted?: boolean) {
  if (!highlighted) {
    return theme.colors.inactive
  }

  return theme.dark ? 'rgba(9,9,11,0.62)' : 'rgba(255,255,255,0.65)'
}

export const ScrollAnchorContext = createContext<{
  registerAnchor: (id: string, y: number) => void
}>({
  registerAnchor: () => undefined,
})

export const ScrollStateContext = createContext<{
  scrollY: { addListener?: (callback: (state: { value: number }) => void) => string; removeListener?: (id: string) => void; __getValue?: () => number }
  viewportHeight: number
  contentRef: React.RefObject<any> | null
}>({
  scrollY: {},
  viewportHeight: 0,
  contentRef: null,
})

export function useScrollAnchors() {
  return useContext(ScrollAnchorContext)
}

export function useScrollState() {
  return useContext(ScrollStateContext)
}

export function openExternal(url: string) {
  if (IS_WEB && typeof window !== 'undefined') {
    window.open(url, '_blank', 'noopener,noreferrer')
  }
}

export const sharedStyles = StyleSheet.create({
  absoluteFill: {
    ...StyleSheet.absoluteFillObject,
  },
})
